// extracted by mini-css-extract-plugin
export default {"baseContainerWrapper":"styles_baseContainerWrapper__FEUYH"};